export interface JournalFeatureFlags {
  bookmarks: boolean;
  highlights: boolean;
  prayers: boolean;
}

export interface JournalSourcePolicy {
  journalEnabled: boolean;
  loadBookmarks: boolean;
  loadHighlights: boolean;
  loadPrayers: boolean;
}

/**
 * One truth table for the three independently deployable Journal sources.
 * Every source is owner-authored. A feature flag can make the route available,
 * but no source may hydrate until auth has resolved to a concrete owner; each
 * store then independently enforces the exact durable owner binding.
 */
export function journalSourcePolicy(
  flags: JournalFeatureFlags,
  authenticatedOwner: boolean,
): JournalSourcePolicy {
  return {
    journalEnabled: flags.bookmarks || flags.highlights || flags.prayers,
    loadBookmarks: flags.bookmarks && authenticatedOwner,
    loadHighlights: flags.highlights && authenticatedOwner,
    loadPrayers: flags.prayers && authenticatedOwner,
  };
}
